import * as httpHolder from './httpHolder';
import moment from 'moment';

export function getSeverityFilters(severityList) {

    var filteredList = severityList.filter(x => x === "AllCrashes");

    var isAllCrash = filteredList.length > 0;

    filteredList = severityList.filter(x => x === "AllCrashesButNonNonCrash");

    var isAllButNonCrash = filteredList.length > 0;

    var list = '';

    if (!isAllCrash && !isAllButNonCrash) {
        /*
            ha selezionato un filtro che non è nè ALL nè all but non crash
        */

        for (let item of severityList) {
            list = list + item + ',';
        }

        // elimino l ultimo carattere ","
        list = list.slice(0, -1);
    }

    if (isAllCrash && !isAllButNonCrash) {
        /*
            vuole vedere tutti i severity quindi filtro vuoto
        */
        return list;
    }

    if (!isAllCrash && isAllButNonCrash) {
        /*
            vuole vedere tutti i severity tranne Noncrash
        */
        list = 'VeryLight,Light,Moderate,Heavy,VeryHeavy';
        return list;
    }

    /*
        se sono entrambi veri (tutti e tutti But non crash) restituisco una lista vuota che vuol dire TUTTI i severity
    */

    return list;

}


export function fetchAllICNList(dateFrom, dateTo, severityList){

    //Invoke api service
    var request =
    {
        search: {
            maxResults: 1000,
            /*
            sort: [
                sort
            ],
            */
            searchTerms: {
                // le date sono obbligatorie
                crashDate: "[" + moment(dateFrom).format("YYYY-MM-DDTHH:mm:ss") + ' TO ' + moment(dateTo).format("YYYY-MM-DDTHH:mm:ss") + "]"
            }
        }
    };

    var severityFilters = getSeverityFilters(severityList);

    if (severityFilters && severityFilters.length > 0) {
        request.search.searchTerms.severityCode = severityFilters;
    }

    return httpHolder.getInstance().post('crashboxx/services/icn/search?hierarchy=true', request);

}

export function fetchAllICNListBySearch(icnId, deviceIdType, deviceFilterValue, vin, dateFrom, dateTo, severityList, device, vehicle, account,
    selectedClassificationValue, includeSubAccount){

    var sort = "-crashDate";

    if(includeSubAccount === undefined)
    {
        includeSubAccount = true;
    }

    //Invoke api service
    var request =
    {
        search: {
            maxResults: 1000,
            sort: [
                sort
            ],
            searchTerms: {
                // le date sono obbligatorie
                crashDate: "[" + moment(dateFrom).format("YYYY-MM-DDTHH:mm:ss") + ' TO ' + moment(dateTo).format("YYYY-MM-DDTHH:mm:ss") + "]"
            }
        }
    };

    if (account) {
        request.search.searchTerms.accountId = account.id;
        request.search.searchTerms.accountIdType = "AccountType";
    }

    if (icnId) {
        request.search.searchTerms.id = icnId;
    }

    if (vehicle && vehicle.id) {
        request.search.searchTerms.assetId = vehicle.id;
    }

    if (device && device.esn) {
        request.search.searchTerms.deviceId = device.esn;
        // per poter filtrare per ESN
        request.search.searchTerms.deviceIdType = "ESN";
    }

    if (deviceFilterValue) {
        request.search.searchTerms.deviceId = deviceFilterValue;
        // per poter filtrare per ESN, Id, IMEI
        request.search.searchTerms.deviceIdType = deviceIdType;
    }

    if (vin) {
        request.search.searchTerms.vin = vin;
    }

    var severityFilters = getSeverityFilters(severityList);

    if (severityFilters && severityFilters.length > 0) {
        request.search.searchTerms.severityCode = severityFilters;
    }

    if (selectedClassificationValue) {
        request.search.searchTerms.eventClassification = selectedClassificationValue;
    }


    return httpHolder.getInstance().post('crashboxx/services/icn/search?hierarchy=' + includeSubAccount, request);

}


export function searchICNList(icnId, deviceIdType, deviceFilterValue, vin, dateFrom, dateTo, severityList, device, vehicle, account,
    selectedClassificationValue, includeSubAccount,
    sortName, isDescending, page, pageSize, cancelToken){
    var sort = "-crashDate";

    if(includeSubAccount === undefined)
    {
        includeSubAccount = true;
    }

    if (sortName) {
        if (isDescending) {
            sort = "-" + sortName;
        } else {
            sort = sortName;
        }
    }

    if (!page) {
        page = 1;
    }

    if (!pageSize) {
        pageSize = 20;
    }

    //Invoke api service
    var request =
    {
        search: {
            sort: [
                sort
            ],
            searchTerms: {
                // le date sono obbligatorie
                crashDate: "[" + moment(dateFrom).format("YYYY-MM-DDTHH:mm:ss") + ' TO ' + moment(dateTo).format("YYYY-MM-DDTHH:mm:ss") + "]"
            }
        }
    };

    if (account) {
        request.search.searchTerms.accountId = account.id;
        request.search.searchTerms.accountIdType = "AccountType";
    }

    if (icnId) {
        request.search.searchTerms.id = icnId;
    }

    if (vehicle && vehicle.id) {
        request.search.searchTerms.assetId = vehicle.id;
    }

    if (device && device.esn) {
        request.search.searchTerms.deviceId = device.esn;
        // per poter filtrare per ESN
        request.search.searchTerms.deviceIdType = "ESN";
    }

    if (deviceFilterValue) {
        request.search.searchTerms.deviceId = deviceFilterValue;
        // per poter filtrare per ESN, Id, IMEI
        request.search.searchTerms.deviceIdType = deviceIdType;
    }

    if (vin) {
        request.search.searchTerms.vin = vin;
    }

    var severityFilters = getSeverityFilters(severityList);

    if (severityFilters && severityFilters.length > 0) {
        request.search.searchTerms.severityCode = severityFilters;
    }

    if (selectedClassificationValue) {
        request.search.searchTerms.eventClassification = selectedClassificationValue;
    }

    var client = httpHolder.getInstance();

    return client.post('crashboxx/services/icn/search?hierarchy=' + includeSubAccount + '&pg=' + page + '&pgsize=' + pageSize, request, {
        cancelToken
    });
}

export function getSearchICNListCancelSource(){
    var source = httpHolder.GetSourceCancelToken();
    return source;
}

export function cancelSearchICNList(source){
    console.info("Cancelling http request ...");
    source.cancel('Operation canceled by the user.');
}

/**
 * get icn by id
 * @param {icn id} id
 */
export function getIcnById(id){
    return httpHolder.getInstance().get('crashboxx/services/icn/' + id, {withCredentials: true});
}

/**
 * get icn plus by id
 * @param {icn id} id
 */
export function getIcnPlusById(id){
    return httpHolder.getInstance().get('crashboxx/services/icnplus/' + id, {withCredentials: true});
}

/**
 * get icn speed by id
 * @param {icn id} id
 */
export function getIcnSpeed(id){
    return httpHolder.getInstance().get('crashboxx/services/icnplus/speeddata/' + id, {withCredentials: true});
}

/**
 * get icn acceleration by id
 * @param {icn id} id
 */
export function getIcnAcceleration(id){
    return httpHolder.getInstance().get('crashboxx/services/icnplus/accelerationpairs/' + id, {withCredentials: true});
}

/**
 * restituisce info sulla lista costo danni
 * @param {} id
 * @returns {}
 */
export function getBillOfMaterials(id) {
    //Invoke api service
    return httpHolder.getInstance().get('crashboxx/services/dent/billofmaterials/' + id, {withCredentials: true});
}

/**
 * esegue update icn - event classification
 * @param {} id
 * @returns {}
 */
export function updateEventClassification(id, classification)  {
    //Invoke api service
    return httpHolder.getInstance().put('crashboxx/services/icn/eventclassification/' + id + '?eventClassification=' + classification, {withCredentials: true});
}


// WEBPACK FOOTER //
// ./src/services/apis/calAmp/icnServices.js